import type { InternalButtonVariant } from './interface';
import { type ButtonColors, CONTAINED_DESTRUCTIVE, CONTAINED_PRIMARY, CONTAINED_SECONDARY, OUTLINED, TEXT_DESTRUCTIVE, TEXT_PRIMARY } from './const';
import { IconName } from '@src/components/Icon';

export function getVariantColors(variant: InternalButtonVariant, color: string): ButtonColors {
  // Contained buttons
  if (variant === 'contained') {
    switch (color) {
      case 'primary': return CONTAINED_PRIMARY;
      case 'secondary': return CONTAINED_SECONDARY;
      case 'destructive': return CONTAINED_DESTRUCTIVE;
    }
  }
  // Outlined buttons
  else if (variant === 'outlined') {
    return OUTLINED;
  }
  // Text buttons
  else if (variant === 'text') {
    switch (color) {
      case 'primary': return TEXT_PRIMARY;
      case 'destructive': return TEXT_DESTRUCTIVE;
    }
  }

  // Default to contained primary
  return CONTAINED_PRIMARY
}

export const iconSizeLookup: Partial<Record<IconName, `${number}px`>> = {
  // THESE DEFAULT TO 18px, so we only need to specify a size if
  // the icon should be a different size

}